// Client-side margin math for the /practice simulator's live preview.
// These MUST match app/services/practice_service.py exactly so the previewed
// liquidation price is the same one the backend records.

export const LEVERAGE_CHOICES = [1, 2, 3, 5] as const
export type Direction = 'long' | 'short'

// Isolated-margin liquidation price. The adverse move that consumes the whole
// collateral is entry / leverage. A long is liquidated below entry, a short
// above; at 1x a long can never be liquidated (price 0).
export function computeLiquidationPrice(
  entryPrice: number,
  leverage: number,
  direction: Direction,
): number {
  const move = entryPrice / leverage
  if (direction === 'long') return Math.max(entryPrice - move, 0)
  return entryPrice + move
}

export function computeNotional(collateral: number, leverage: number): number {
  return collateral * leverage
}

export function computeQuantity(
  collateral: number,
  leverage: number,
  entryPrice: number,
): number {
  if (!entryPrice) return 0
  return computeNotional(collateral, leverage) / entryPrice
}

// The fractional adverse move (as a %) to liquidation: 100 / leverage.
export function liquidationDistancePct(leverage: number): number {
  return 100 / leverage
}
